<script setup lang="ts">
const props = defineProps<{
  title: string
  desc: string
  iconId: string
  ctaLabel?: string
  ctaDisabled?: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'go'): void
}>()

function withBase(p: string) {
  return `${import.meta.env.BASE_URL || '/'}${String(p || '').replace(/^\//, '')}`
}

function iconStyle() {
  const url = withBase(`/assets/ai-tool-icons/${String(props.iconId || '').trim()}.svg`)
  return {
    WebkitMaskImage: `url(${url})`,
    maskImage: `url(${url})`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    backgroundColor: 'currentColor',
  } as any
}
</script>

<template>
  <div
    class="bg-surface-container-low rounded-xl p-4 flex flex-col gap-3 shadow-sm transition-colors overflow-hidden h-full min-h-[160px] box-border"
    :class="props.disabled ? 'cursor-default' : 'hover:bg-surface-container-high cursor-pointer'"
    :role="props.disabled ? undefined : 'button'"
    :tabindex="props.disabled ? -1 : 0"
    @click="!props.disabled && emit('go')"
  >
    <div class="flex gap-4 items-start h-full min-h-0">
      <div class="w-12 h-12 rounded-2xl bg-white/6 border border-white/10 text-highlight flex items-center justify-center flex-none">
        <span class="w-7 h-7" aria-hidden="true" :style="iconStyle()" />
      </div>
      <div class="min-w-0 flex-1 flex flex-col gap-2 h-full min-h-0">
        <div>
          <p class="text-lg font-extrabold text-on-surface font-manrope leading-tight truncate">{{ props.title }}</p>
          <p
            class="text-sm text-on-surface-variant mt-2 leading-relaxed overflow-hidden"
            style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical"
          >
            {{ props.desc }}
          </p>
        </div>
        <div class="mt-auto pt-2">
          <button
            v-if="!props.ctaDisabled"
            class="inline-flex items-center gap-2 px-5 py-3 rounded-[var(--radius-btn)] bg-accent text-white font-black text-sm hover:opacity-90 transition-opacity"
            type="button"
            :disabled="props.disabled"
            @click.stop="emit('go')"
          >
            <span>{{ props.ctaLabel || '去使用' }}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="text-white/90">
              <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <span
            v-else
            class="inline-flex items-center px-4 py-2 rounded-full border border-white/16 text-on-surface font-extrabold text-sm"
            aria-label="即将上线"
          >
            {{ props.ctaLabel || '即将上线' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
